export default "__VITE_PUBLIC_ASSET__eb159f2f__"